<template>
  <router-view class="main-content"/>
  <!-- 强制横屏提示遮罩 (默认隐藏，特定条件下显示) -->
  <div id="orientation-lock">
    <div class="lock-content">
      <!-- 一个简单的手机旋转 SVG 图标 -->
      <!-- <svg viewBox="0 0 1024 1024" width="60" height="60" fill="#ffffff">
        <path d="M822.4 563.2c-19.2 0-32-12.8-32-32V294.4c0-60.8-48-108.8-108.8-108.8H204.8c-12.8 0-25.6-3.2-38.4-9.6C121.6 153.6 96 112 96 64c0-19.2 12.8-32 32-32s32 12.8 32 32c0 12.8 9.6 22.4 22.4 28.8 3.2 3.2 9.6 3.2 12.8 3.2h486.4c96 0 172.8 76.8 172.8 172.8v262.4c0 19.2-12.8 32-32 32z m-268.8 304c-12.8 0-22.4-9.6-28.8-22.4-3.2-3.2-3.2-9.6-3.2-12.8V345.6c0-44.8 35.2-80 80-80h262.4c44.8 0 80 35.2 80 80v486.4c0 44.8-35.2 80-80 80H553.6z m64-502.4c-9.6 0-16 6.4-16 16v486.4c0 9.6 6.4 16 16 16h262.4c9.6 0 16-6.4 16-16V345.6c0-9.6-6.4-16-16-16H617.6zM281.6 928c-19.2 0-32-12.8-32-32V752c0-19.2 12.8-32 32-32s32 12.8 32 32v144c0 19.2-12.8 32-32 32z m-160-32c0-19.2-12.8-32-32-32H44.8C25.6 864 12.8 876.8 12.8 896s12.8 32 32 32h44.8c19.2 0 32-12.8 32-32z m352-256c-19.2 0-32-12.8-32-32V256c0-19.2 12.8-32 32-32s32 12.8 32 32v352c0 19.2-12.8 32-32 32z m0 320c-19.2 0-32-12.8-32-32v-96c0-19.2 12.8-32 32-32s32 12.8 32 32v96c0 19.2-12.8 32-32 32z" />
      </svg> -->
      <svg t="1765508631505" class="icon" viewBox="0 0 2180 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8077" width="256" height="256"><path d="M44.043011 115.612903L44.043011 908.387097C44.043011 962.569176 87.527226 1006.59567 141.501018 1007.471025L143.139785 1007.483871l1893.849462 0c54.182079 0 98.208573-43.484215 99.096775-97.458007L2136.086022 115.612903c0-54.182079-43.484215-98.208573-97.458008-99.083928L2036.989247 16.516129 143.139785 16.516129c-54.729864 0-99.096774 44.36691-99.096774 99.096774z m2036.989247-110.107527c54.729864 0 99.096774 44.36691 99.096774 99.096775L2180.129032 919.397849c0 54.729864-44.36691 99.096774-99.096774 99.096775L616.602151 1018.494624a5.505376 5.505376 0 0 1-5.505377 5.505376l-71.569892 0a5.505376 5.505376 0 0 1-5.505377-5.505376l-66.064516 0a5.505376 5.505376 0 0 1-5.505376 5.505376L308.301075 1024a5.505376 5.505376 0 0 1-5.505376-5.505376L99.096774 1018.494624C44.36691 1018.494624 0 974.127713 0 919.397849l0-814.795698c0-54.729864 44.36691-99.096774 99.096774-99.096775l203.698925 0 0-2.752688a2.752688 2.752688 0 0 1 2.752688-2.752688l104.602151 0a2.752688 2.752688 0 0 1 2.752688 2.752688l0 2.752688 1668.129032 0z" fill="#ffffff" p-id="8078"></path><path d="M148.645161 123.870968c0-19.764301-16.020645-35.784946-35.784946-35.784946S77.075269 104.106667 77.075269 123.870968 93.095914 159.655914 112.860215 159.655914s35.784946-16.020645 35.784946-35.784946z" fill="#ffffff" p-id="8079"></path><path d="M112.860215 123.870968m0 17.892473a17.892473 17.892473 0 1 0 0-35.784946 17.892473 17.892473 0 1 0 0 35.784946Z" fill="#ffffff" opacity=".7" p-id="8080"></path><path d="M106.896057 129.835125m0 5.964158a5.964158 5.964158 0 1 0 0-11.928315 5.964158 5.964158 0 1 0 0 11.928315Z" fill="#ffffff" p-id="8081"></path><path d="M122.953405 116.530466m0 2.752688a2.752688 2.752688 0 1 0 0-5.505376 2.752688 2.752688 0 1 0 0 5.505376Z" fill="#ffffff" p-id="8082"></path></svg>
      <p style="font-size: 18px; margin-top: 20px;">为了更好的体验，请将手机横屏浏览</p>
    </div>
  </div>
</template>
<script setup>
import { onMounted, onUnmounted } from "vue";

// PC端设计稿核心宽度，建议不要设太大，2000px有点过于宽了，通常 1440-1600 体验较好
// 这里沿用你的设定
const DESIGN_WIDTH = 2000; 

const updateViewport = () => {
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if (!isMobile) {
    // PC端：使用默认逻辑
    meta.setAttribute('content', 'width=device-width, initial-scale=1.0');
    return;
  }

  // 获取屏幕宽高，判断横竖屏
  const width = window.innerWidth;
  const height = window.innerHeight;
  // 宽 > 高 认为是横屏
  const isLandscape = width > height;

  if (isLandscape) {
    // 【横屏状态】：应用 PC 宽度，让网页缩放以适应手机屏幕
    // initial-scale=1.0 必须去掉，否则安卓无法缩小
    meta.setAttribute('content', `width=${DESIGN_WIDTH}, user-scalable=yes`);
  } else {
    // 【竖屏状态】：应用 手机原生宽度
    // 这样遮罩层的文字和图标才能正常显示（不会被缩小10倍）
    meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
  }
};

onMounted(() => {
  // 初始化执行
  updateViewport();
  
  // 监听屏幕旋转或尺寸变化
  // 安卓手机旋转时，resize 事件触发更可靠
  window.addEventListener('resize', () => {
    // 加一点延迟，防止安卓机在旋转动画未结束时获取到错误的宽高
    setTimeout(updateViewport, 200);
  });
  window.addEventListener('orientationchange', () => {
    setTimeout(updateViewport, 200);
  });
});

onUnmounted(() => {
  // 记得销毁监听，虽然后台管理系统通常不销毁 App.vue
  window.removeEventListener('resize', updateViewport);
  window.removeEventListener('orientationchange', updateViewport);
});
</script>
<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  font-size: 14px;
  background-color: #f8f8f8;
  min-height: calc(var(--vh, 1vh) * 100);
  min-width: 1400px;
}


nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

/* 
  默认样式：隐藏遮罩 
  在 PC 端或横屏时，这个遮罩是看不见的
*/
#orientation-lock {
  display: none; 
}

/* 
  核心逻辑：
  当设备是 竖屏 (portrait) 
  并且 宽度小于 1024px (排除掉竖着放的 PC 显示器)
  时，显示遮罩 
*/
@media screen and (orientation: portrait) and (max-width: 2500px) {
  #orientation-lock {
    display: flex;        /* 启用 Flex 布局让内容居中 */
    position: fixed;      /* 钉死在屏幕上 */
    top: 0;
    left: 0;
    width: 100vw;         /* 占满全屏宽 */
    height: 100vh;        /* 占满全屏高 */
    background-color: #323232; /* 深色背景 */
    color: #fff;          /* 白色文字 */
    z-index: 99999;       /* 层级最高，盖住所有内容 */
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    /* 禁止用户在遮罩上操作 */
    touch-action: none;   
  }

  .lock-content svg {
    margin-bottom: 20px;
    animation: rotate-anim 1.5s infinite ease-in-out; /* 加个旋转动画提示 */
  }

  .lock-content p {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
  }
}

/* 定义一个小动画，让手机图标动起来，更直观 */
@keyframes rotate-anim {
  0% { transform: rotate(0deg); }
  50% { transform: rotate(-90deg); } /* 模拟向左横屏 */
  100% { transform: rotate(0deg); }
}
</style>
